module.exports = __webpack_public_path__ + "img/8-1.4307b03d.jpg";